module.exports = __webpack_public_path__ + "media/college_scholarships/create-a-profile-ded64db4.png";